import { createSlice } from "@reduxjs/toolkit";

import Utils from "./Utils";
const { clearAllState } = Utils();

const initialState = {
  token: localStorage.getItem("token"),
  isAuthenticated: !!localStorage.getItem("token"),
  sessionExpired: false,
  userId: localStorage.getItem("userId"),
  email: localStorage.getItem("email"),
  role: localStorage.getItem("role"),
  language: localStorage.getItem("language") || "en",
};

const authenticationSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    login(state, action) {
      const { token, userId, email, role, language } = action.payload;
      console.log({ token, userId, email, role, language });
      localStorage.setItem("token", token);
      localStorage.setItem("userId", userId);
      localStorage.setItem("email", email);
      localStorage.setItem("role", role);
      localStorage.setItem("language", language || "en");

      state.token = token;
      state.isAuthenticated = true;
      state.userId = userId;
      state.email = email;
      state.role = role;
      state.language = language || "en";
    },

    logout(state) {
      // console.log("logging out...");
      localStorage.removeItem("token");
      localStorage.removeItem("userid");
      localStorage.removeItem("email");
      localStorage.removeItem("role");
      localStorage.removeItem("language");

      clearAllState();
      state.token = null;
      state.isAuthenticated = false;
      state.userId = null;
      state.email = null;
      state.role = null;
      state.language = "en";
    },
    setToken(state, action) {
      const { token } = action.payload;
      state.token = token;
    },
  },
});

export const authenticationActions = authenticationSlice.actions;
export default authenticationSlice.reducer;
